import React, { Component } from 'react'
import { 
  Modal, Checkbox, 
  Form, FormGroup, ControlLabel, FormControl, 
  Glyphicon
} from 'react-bootstrap'

import Button from '../components/Button.jsx'
import { l } from '../../lib/Tools.js'
import { getText } from '../lib/text'

type Props = {
  id: string, 
  settings: Object, 
  dirty: boolean, 
  update: (string, any) => void, 
  close: () => void 
}

const PdfSettingsModal = ({ id, settings, update, close, dirty }: Props) => (
  <Modal show bsSize="large" onHide={() => close()}>
    <Modal.Header closeButton>
      <Modal.Title>{getText("Configuración del PDF")} (<Glyphicon glyph="star" />)</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <iframe 
        id="tripPdfSettingsIframe"
        width={840}
        height={500}
        className="shrunken"
        src={`/page/doc1pages/doc1ticket/${id}?_id=ticket&type=doc1ticket&name=Presupuesto&fixed=true&border=true`} 
      />

      <div style={{ position: "relative" }}>
        <Form inline>

          <Checkbox
            style={{ marginLeft: 20, marginBottom: 10, marginTop: 20 }}
            checked={settings.proposalIncludesPrice}
            onChange={evt => update({ ...settings, proposalIncludesPrice: evt.target.checked })}
          >
            {getText("Incluir precio")}
          </Checkbox>

          <br />

          <FormGroup style={{ marginLeft: 20 }}>
            <ControlLabel style={{width: 140}}>{getText("Columnas por página")}: </ControlLabel>
            <FormControl
              componentClass="input" 
              type="range"
              style={{ width: 100 }}
              min={2}
              max={4}
              value={settings.columnsPerPage}
              onChange={evt => update({ ...settings, columnsPerPage: parseInt(evt.target.value) })}
            />
            <span>({settings.columnsPerPage})</span>
          </FormGroup>

          <br />

          <FormGroup style={{ marginLeft: 20 }}>
            <ControlLabel style={{width: 140}}>{getText("Tamaño columnas")}: </ControlLabel>
            <FormControl 
              componentClass="input" 
              type="range"
              style={{ width: 150 }}
              min={23}
              max={38}
              value={settings.columnSize}
              onChange={evt => update({ ...settings, columnSize: parseInt(evt.target.value) })}
            />
            <span>({settings.columnSize})</span>
          </FormGroup>

          <br />

          <FormGroup style={{ marginLeft: 20 }}>
            <ControlLabel style={{width: 140}}>{getText("Tamaño fuente")}: </ControlLabel>
            <FormControl 
              componentClass="input" 
              type="range"
              style={{ width: 150 }}
              min={12}
              max={30}
              value={settings.fontSize}
              onChange={evt => update({ ...settings, fontSize: parseInt(evt.target.value) })}
            />
            <span>({settings.fontSize}px)</span>
          </FormGroup>

          <div style={{ position: "absolute", top: 10, right: 40 }}>
            <Button
              style={{ marginLeft: 120 }}
              glyph="refresh"
              disabled={dirty}
              onClick={() => {
                const iframe = document.getElementById("tripPdfSettingsIframe")
                iframe.src = iframe.src 
              }}
            >
              { dirty ? getText("Guardando...") : getText("Refrescar preview") }
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              glyph="resize-full"
              onClick={() => window.open(
                `/page/doc1pages/doc1ticket/${id}?_id=ticket&type=doc1ticket&name=Presupuesto&fixed=true&border=true`, 
                "_blank")}
            >
              {getText("Ver grande")}
            </Button>
          </div>
        </Form>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={() => close()}>{getText("Cerrar")}</Button>
    </Modal.Footer>
  </Modal>
)

export default PdfSettingsModal

